import React from "react";
import { AddNewChannelModal } from "./modals/AddNewChannelModal";
import { EditChannelModal } from "./modals/EditChannelModal";
import { NewMessageModal } from "./modals/NewMessageModal";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import CommunityChatWrapper from "./CommunityChatWrapper";

const CommunityChatController = async ({ api, res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};
  const { activeUser, activeUserToRequest } = locals;

  activeUser.organizationId
    ? await load("activeCommunityChatClientsList", {
        organizationUser: activeUserToRequest._id,
      })
    : await load("activeCommunityChatClientsList", {});

  if (modal?.type === "edit-community-channel" && activeUser.organizationId) {
    await load("usersOrganization");
  }

  locals.modal = {
    "new-community-channel": <AddNewChannelModal locals={locals} />,
    "edit-community-channel": <EditChannelModal locals={locals} api={api} />,
    "new-community-message": <NewMessageModal locals={locals} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <CommunityChatWrapper api={api} />;
};

export default CommunityChatController;
